import { Component } from '@angular/core'

@Component({
  selector: 'shared-auth-progress',
  standalone: true,
  template: `<main aria-busy="true" aria-label="Loading Kartorium">
    <section><img src="assets/logo.png" alt="Kartorium" width="58" height="58">
      <div class="progress-copy" role="status"><span class="spinner" aria-hidden="true"></span>
        <p>Loading Kartorium…</p></div>
    </section>
  </main>`,
  styleUrl: './auth-progress.component.css',
})
export class AuthProgressComponent {}
